import { Stack, Typography, useTheme } from "@mui/material";
import type { FC } from "react";
import { AmountStepper } from "web_myplann/Shared/Components/AmountStepper";
import { INCREMENTAL_COUNTER_V2_STEP } from "web_myplann/Shared/constants";

type Props = {
	label: string;
	value: number;
	onChange: (value: number) => void;
	readOnly?: boolean;
	readOnlyHint?: string;
};

export const IncrementalCounterV2: FC<Props> = ({
	label,
	value,
	onChange,
	readOnly = false,
	readOnlyHint,
}) => {
	const theme = useTheme();

	return (
		<Stack
			alignItems="center"
			bgcolor={theme.palette.background.paper}
			pt={theme.spacingTokens.sm}
			pb={theme.spacingTokens.lg}
			gap={theme.spacingTokens.sm}
		>
			<Typography
				variant="body2"
				color={readOnly ? theme.palette.grey[400] : undefined}
			>
				{label}
			</Typography>

			<Stack direction="row" alignItems="center" gap={theme.spacingTokens.xl}>
				<AmountStepper
					size="lg"
					value={value}
					onChange={onChange}
					step={INCREMENTAL_COUNTER_V2_STEP}
					readOnly={readOnly}
					valueColor={
						readOnly ? theme.palette.grey[400] : theme.palette.text.primary
					}
				/>
			</Stack>

			{readOnly && readOnlyHint && value > 0 && (
				<Typography variant="hint">{readOnlyHint}</Typography>
			)}
		</Stack>
	);
};
